import React from 'react';

const CreateNotice = ({ notice, uncertain, on_retry, refusal, on_show_run }) => (
  <>
    {notice ? (
      <div className={`tp-banner tp-banner-${uncertain ? 'warn' : 'info'}`} role="status">
        {notice}{' '}
        {uncertain ? (
          <button type="button" className="tp-link" onClick={on_retry}>
            Try again
          </button>
        ) : null}
      </div>
    ) : null}
    {refusal ? (
      <div className="tp-banner tp-banner-warn" role="alert">
        {refusal.message}{' '}
        {refusal.run_uuid ? (
          <button type="button" className="tp-link" onClick={() => on_show_run(refusal.run_uuid)}>
            Show that run
          </button>
        ) : null}
      </div>
    ) : null}
  </>
);

export default CreateNotice;
